import { createContext } from "react";

export const BarriosContext = createContext()
export const BarriosFormContext = createContext()
export const BarriosReportContext = createContext()